import type { Dictionary } from './en';

/* Thai UI strings, metric-matched to the English keys. */
export const th: Dictionary = {
  brand: { name: 'Warm Paper ED', tagline: 'การเรียนรู้แผนกฉุกเฉิน' },
  nav: {
    home: 'หน้าหลัก',
    catalog: 'หลักสูตร',
    learning: 'การเรียนของฉัน',
    wallet: 'ใบรับรอง',
    profile: 'โปรไฟล์',
    courses: 'หลักสูตร',
    attend: 'การเข้าร่วม',
    certs: 'ใบรับรอง',
    approve: 'การอนุมัติ',
    users: 'ผู้ใช้',
    verify: 'ตรวจสอบ',
    org: 'หน่วยงาน',
    reports: 'รายงาน',
    dashboard: 'แดชบอร์ด',
  },
  common: {
    search: 'ค้นหา',
    all: 'ทั้งหมด',
    enroll: 'ลงทะเบียน',
    continue: 'เรียนต่อ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    back: 'ย้อนกลับ',
    next: 'ถัดไป',
    submit: 'ส่ง',
    approve: 'อนุมัติ',
    decline: 'ปฏิเสธ',
    seats: 'ที่นั่ง',
    hours: 'ชม.',
    signOut: 'ออกจากระบบ',
  },
  auth: {
    continueTelegram: 'เข้าสู่ระบบด้วย Telegram',
    staffOnly: 'เฉพาะบุคลากรเท่านั้น · Hospital staff only',
    valueProp: 'การอบรม ใบรับรอง และการเช็คอิน — รวมไว้ในที่เดียว',
    authorize: 'อนุญาต',
    pending: 'รอการอนุมัติ',
    exploreWhileWait: 'สำรวจระหว่างรอ',
  },
  roles: {
    staff: 'บุคลากร',
    instructor: 'ผู้สอน',
    admin: 'ผู้ดูแล',
    superadmin: 'ผู้ดูแลระบบสูงสุด',
  },
  toast: {
    saved: 'บันทึกแล้ว',
    issued: 'ออกใบรับรองแล้ว',
    approved: 'อนุมัติแล้ว',
  },
};
